import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const OutcomeHashtagIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M13.3337 5.5C13.6097 5.50018 13.8337 5.72397 13.8337 6C13.8337 6.27603 13.6097 6.49982 13.3337 6.5H2.66669C2.39054 6.5 2.16669 6.27614 2.16669 6C2.16669 5.72386 2.39054 5.5 2.66669 5.5H13.3337Z"
      fill="currentColor"
    />
    <path
      d="M13.3337 9.5C13.6097 9.50018 13.8337 9.72397 13.8337 10C13.8337 10.276 13.6097 10.4998 13.3337 10.5H2.66669C2.39054 10.5 2.16669 10.2761 2.16669 10C2.16669 9.72386 2.39054 9.5 2.66669 9.5H13.3337Z"
      fill="currentColor"
    />
    <path
      d="M6.72203 1.50292C6.99643 1.53347 7.19393 1.78123 7.16344 2.05565L5.83043 14.0557C5.79973 14.3299 5.55201 14.5275 5.2777 14.4971C5.00347 14.4664 4.80581 14.2186 4.83629 13.9443L6.1693 1.94432C6.19999 1.67008 6.44771 1.47244 6.72203 1.50292Z"
      fill="currentColor"
    />
    <path
      d="M10.722 1.50292C10.9964 1.53347 11.1939 1.78123 11.1634 2.05565L9.83043 14.0557C9.79973 14.3299 9.55201 14.5275 9.2777 14.4971C9.00347 14.4664 8.80581 14.2186 8.83629 13.9443L10.1693 1.94432C10.2 1.67008 10.4477 1.47244 10.722 1.50292Z"
      fill="currentColor"
    />
  </svg>
);
